import React, { useContext } from 'react';
import { Dropdown } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTag, faTimes, faChevronDown, faCheck } from '@fortawesome/free-solid-svg-icons';
import AppContext from 'context/Context';

const EtiquetaFilterSelect = ({
  selectedEtiquetaId,
  onSelectEtiqueta,
  etiquetas = [],
  isLoading = false,
  variant = 'default',
  className = '',
  hideIcon = false,
  showIcon = true
}) => {
  const { config: { isDark } = {} } = useContext(AppContext);
  const filteredEtiquetas = etiquetas.filter(et => Number(et.iEstadoIncidencia) === 2);

  if (variant === 'chip') {
    const isSelected = Boolean(selectedEtiquetaId);
    const selectedEtiqueta = filteredEtiquetas.find(et => String(et.idEtiqueta) === String(selectedEtiquetaId));
    const labelText = selectedEtiqueta ? selectedEtiqueta.vNombre : 'Todas las incidencias';
    const isFullWidth = className && className.includes('w-100');

    return (
      <Dropdown className={`flex-shrink-0 ${className ? className : 'd-inline-block'}`}>
        <Dropdown.Toggle
          as="div"
          role="button"
          tabIndex={0}
          className={`d-inline-flex align-items-center gap-1.5 px-3 py-1 rounded-pill shadow-none dropdown-caret-none ${isFullWidth ? 'w-100 justify-content-between' : ''}`}
          style={{
            cursor: 'pointer',
            minWidth: 0,
            backgroundColor: isSelected
              ? (isDark ? 'rgba(245, 158, 11, 0.15)' : '#fef3c7')
              : (isDark ? '#1e293b' : '#ffffff'),
            color: isSelected
              ? (isDark ? '#fbbf24' : '#b45309')
              : (isDark ? '#cbd5e1' : '#334155'),
            border: isSelected
              ? (isDark ? '1px solid rgba(245, 158, 11, 0.35)' : '1px solid #fde68a')
              : (isDark ? '1px solid #334155' : '1px solid #e2e8f0'),
            fontSize: '0.80rem',
            fontWeight: 500,
            whiteSpace: 'nowrap'
          }}
        >
          <div className="d-flex align-items-center gap-1.5 overflow-hidden flex-grow-1 min-w-0 me-1" style={{ minWidth: 0 }}>
            {showIcon && !hideIcon && (
              <FontAwesomeIcon
                icon={faTag}
                className="flex-shrink-0"
                style={{ fontSize: '0.72rem', color: isSelected ? (isDark ? '#fbbf24' : '#d97706') : '#f59e0b' }}
              />
            )}
            <span className="text-truncate">
              {labelText}
            </span>
          </div>

          <div className="d-flex align-items-center flex-shrink-0 ms-auto">
            {isSelected && (
              <span
                role="button"
                tabIndex={0}
                onClick={e => {
                  e.stopPropagation();
                  onSelectEtiqueta('');
                }}
                className="me-1 d-inline-flex align-items-center justify-content-center"
                style={{
                  width: '16px',
                  height: '16px',
                  borderRadius: '50%',
                  cursor: 'pointer'
                }}
                title="Quitar filtro de incidencia"
              >
                <FontAwesomeIcon icon={faTimes} style={{ fontSize: '0.68rem' }} />
              </span>
            )}
            <FontAwesomeIcon icon={faChevronDown} style={{ fontSize: '0.65rem', opacity: 0.7 }} />
          </div>
        </Dropdown.Toggle>

        <Dropdown.Menu
          className={`shadow-lg border py-1 ${isDark ? 'bg-dark' : 'bg-white'}`}
          style={{
            minWidth: '220px',
            maxHeight: '300px',
            overflowY: 'auto',
            zIndex: 1050,
            borderColor: isDark ? '#334155' : '#e2e8f0'
          }}
        >
          <Dropdown.Item
            as="button"
            type="button"
            className={`se-agent-dropdown-item ${!selectedEtiquetaId ? 'se-item-selected-blue' : ''}`}
            onClick={() => onSelectEtiqueta('')}
          >
            <div className="d-flex align-items-center gap-2 overflow-hidden flex-grow-1">
              <FontAwesomeIcon icon={faTag} className="flex-shrink-0" style={{ width: '16px', color: '#94a3b8' }} />
              <span>Incidencias en progreso</span>
            </div>
            {!selectedEtiquetaId && <FontAwesomeIcon icon={faCheck} className="ms-auto" />}
          </Dropdown.Item>

          {filteredEtiquetas.map(et => {
            const isEtSelected = String(selectedEtiquetaId) === String(et.idEtiqueta);
            return (
              <Dropdown.Item
                key={et.idEtiqueta}
                as="button"
                type="button"
                className={`se-agent-dropdown-item ${isEtSelected ? 'se-item-selected-blue' : ''}`}
                onClick={() => onSelectEtiqueta(String(et.idEtiqueta))}
              >
                <div className="d-flex align-items-center gap-2 overflow-hidden flex-grow-1">
                  <FontAwesomeIcon icon={faTag} className="flex-shrink-0" style={{ width: '16px', color: '#f59e0b' }} />
                  <span className="text-truncate">{et.vNombre}</span>
                </div>
                {isEtSelected && <FontAwesomeIcon icon={faCheck} className="ms-auto" />}
              </Dropdown.Item>
            );
          })}
        </Dropdown.Menu>
      </Dropdown>
    );
  }

  return (
    <div className="d-flex align-items-center gap-2 se-etiqueta-filter-container position-relative">
      <label
        htmlFor="tickets-etiqueta-filter-select"
        className="d-flex align-items-center gap-1 text-600 mb-0 fw-semibold"
        style={{ fontSize: '0.80rem', whiteSpace: 'nowrap' }}
      >
        <FontAwesomeIcon
          icon={faTag}
          style={{ color: selectedEtiquetaId ? (isDark ? '#a78bfa' : '#7c3aed') : (isDark ? '#94a3b8' : '#64748b') }}
        />
        <span>Incidencia:</span>
      </label>

      <div className="position-relative d-inline-flex align-items-center">
        <select
          id="tickets-etiqueta-filter-select"
          className="form-select form-select-sm border shadow-none text-900 fw-semibold"
          style={{
            fontSize: '0.82rem',
            borderRadius: '8px',
            cursor: 'pointer',
            backgroundColor: isDark ? '#1e293b' : '#f8fafc',
            borderColor: selectedEtiquetaId ? (isDark ? '#7c3aed' : '#a78bfa') : (isDark ? '#233142' : '#e2e8f0'),
            color: isDark ? '#f8fafc' : '#334155',
            paddingRight: selectedEtiquetaId ? '32px' : undefined,
            minWidth: '160px',
            maxWidth: '210px'
          }}
          value={selectedEtiquetaId || ''}
          onChange={e => onSelectEtiqueta(e.target.value)}
          disabled={isLoading && filteredEtiquetas.length === 0}
          title="Filtrar tickets por tipo de incidencia"
        >
          <option value="">Todas las incidencias</option>
          {filteredEtiquetas.map(et => (
            <option key={et.idEtiqueta} value={String(et.idEtiqueta)}>
              {et.vNombre}
            </option>
          ))}
        </select>

        {selectedEtiquetaId && (
          <button
            type="button"
            className="btn btn-link position-absolute p-0 text-muted border-0 shadow-none"
            style={{
              right: '24px',
              top: '50%',
              transform: 'translateY(-50%)',
              fontSize: '0.70rem',
              lineHeight: 1
            }}
            onClick={() => onSelectEtiqueta('')}
            title="Quitar filtro de incidencia"
          >
            <FontAwesomeIcon icon={faTimes} />
          </button>
        )}
      </div>
    </div>
  );
};

export default EtiquetaFilterSelect;
